
import React, { useState } from 'react';
import { Button } from '../ui/button';
import { Checkbox } from '../ui/checkbox';
import { Badge } from '../ui/badge';
import { Download, Trash, Tag, Edit, FileText } from 'lucide-react';
import { Document, DocumentType } from '../../types/dataRoom';
import { formatDocumentType } from '../../utils/documentUtils';

interface DocumentItemProps {
  doc: Document;
  toggleDocumentSelection: (documentId: string) => void;
  openEditTags: (documentId: string, tags: string[]) => void;
  openEditType: (documentId: string, type: DocumentType) => void;
  handleViewDocument: (document: string, name: string) => void;
  downloadDocuments: (documents: Document[]) => void;
  removeDocument: (documentId: string) => void;
}

const DocumentItem: React.FC<DocumentItemProps> = ({
  doc,
  toggleDocumentSelection,
  openEditTags,
  openEditType,
  handleViewDocument,
  downloadDocuments,
  removeDocument
}) => {
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
const [documentToDelete, setDocumentToDelete] = useState<Document | null>(null);



  return (
    <div className="flex items-center p-1 hover:bg-gray-50">
      <div className="w-10">
        <Checkbox 
          checked={doc.isSelected}
          onCheckedChange={() => toggleDocumentSelection(doc.id)}
        />
      </div>
      <div className="flex-1 flex items-center ml-2">
        <FileText className="h-4 w-4 mr-2 text-gray-400" />
        <span className="text-sm">{doc.name}</span>
      </div>
      <div className="w-fit text-center flex justify-center gap-1">
        <Badge 
          variant="outline" 
          className="bg-amber-50 text-amber-800 hover:bg-amber-100 cursor-pointer"
          onClick={() => openEditTags(doc.id, doc.tags || [])}
        >
          <Tag className="h-3 w-3 mr-1" />
          {doc.type || formatDocumentType(doc.type)}
        </Badge>
        <Button 
          variant="ghost" 
          size="icon" 
          className="h-5 w-5"
          onClick={() => openEditType(doc.id, doc.type)}
        >
          <Edit className="h-3 w-3" />
        </Button>
      </div>
      <div className="w-48 text-center text-sm text-gray-500">
        {doc.uploadedAt.toLocaleString('en-US', {
          hour: 'numeric',
          minute: 'numeric',
          hour12: true,
          day: 'numeric',
          month: 'short',
          year: 'numeric'
        })}
      </div>
      
      <div className="w-36 flex justify-center space-x-1">
        <Button 
          variant="ghost" 
          size="icon"
          onClick={() => {
            if (doc.url) {
              handleViewDocument(doc.url, doc.name);
            }
          }}
        >
          <FileText className="h-4 w-4 text-blue-500" />
        </Button>
        <Button 
          variant="ghost" 
          size="icon"
          onClick={() => downloadDocuments([doc])}
        >
          <Download className="h-4 w-4" />
        </Button>
        <Button
  variant="ghost"
  size="icon"
  onClick={() => {
    setDocumentToDelete(doc); // set the document you want to delete
    setIsDeleteDialogOpen(true); // open modal
  }}
>
  <Trash className="h-4 w-4 text-red-500" />
</Button>
      </div>

      {isDeleteDialogOpen && documentToDelete && (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-opacity-50">
    <div className="bg-white p-6 rounded-xl shadow-lg max-w-sm w-full">
      <h2 className="text-lg font-semibold mb-4">Confirm Deletion</h2>
      <p className="text-sm text-gray-600 mb-6">
        Are you sure you want to delete <strong>{documentToDelete.name}</strong>?
      </p>

      <div className="flex justify-end gap-2">
        <button
          className="px-4 py-2 text-sm rounded-md border border-gray-300 hover:bg-gray-100"
          onClick={() => {
            setIsDeleteDialogOpen(false);
            setDocumentToDelete(null);
          }}
        >
          Cancel
        </button>

        <button
          className="px-4 py-2 text-sm rounded-md bg-red-600 text-white hover:bg-red-700"
          onClick={() => {
            removeDocument(documentToDelete.id);
            setIsDeleteDialogOpen(false);
            setDocumentToDelete(null);
          }}
        >
          Delete
        </button>
      </div>
    </div>
  </div>
)}

    </div>

    
  );
};

export default DocumentItem;
